/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Krzysztof Gregorowicz <gregorowicz.k@gmail.com>, February 2017
 */

import React, { PropTypes } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { Tabs, Tab } from 'react-bootstrap';
import s from '../Login.css';

class ResetPassword extends React.Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
  };
  constructor(props) {
    super(props);
    this.state = {
      tabKey: 'email',
      username: '',
      email: '',
      formSent: false,
      errorMessage: null,
      timeToFire: 10,
    };
  }

  executeOnSubmit = e => {
    e.preventDefault();

    fetch('/resetPassword', {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      body: this.state.tabKey === 'email' ?
        JSON.stringify({
          email: this.state.email,
        }) :
        JSON.stringify({
          username: this.state.username,
        }),
    })
      .then(response => response.json())
      .then(responseJson => {
        if (responseJson.success) {
          this.setState({ formSent: true });
        } else this.setState({ formSent: false });
      })
      .catch((error) => {
        const msg = 'Nie udało się zresetować hasła';
        this.setState({ errorMessage: msg });
        console.error(error);
      });
  }

  handleSelect = tabKey => {
    this.setState({tabKey: tabKey});
  }
  handleEmailChange = e => {
    this.setState({ email: e.target.value });
  }
  handleUsernameChange = e => {
    this.setState({ username: e.target.value });
  }
  formSentSuccessMessage = () => {
    this.state.errorMessage !== null ? this.setState({ errorMessage: null }) : null;
    const counter = () => {
      let timeToFire = this.state.timeToFire;
      setInterval(() => {
        timeToFire -= 1;
        this.setState({ timeToFire });
        if (timeToFire <= 0) {
          const redirect = '/confirmPassword';
          window.location.href = redirect;
        }
      }, 1000);
    };
    counter();
  }

  render() {
    return (
      <div className={s.root}>
        <div className={s.container}>
          <h1>{this.props.title}</h1>
          <div className={s.resetInfo}>Aby zresetować hasło, podaj swoją nazwę użytkownika lub adres email.</div>

          <form method="post" onSubmit={this.executeOnSubmit}>
            <div className={s.formGroup}>
              <Tabs defaultActiveKey={this.state.tabKey} onSelect={this.handleSelect} id="resetPass">
                <Tab eventKey={'email'} title="Email" tabClassName={s.resetTab}>
                  <label className={s.label} htmlFor="email">
                    Email:
                  </label>
                  <input
                    className={s.input}
                    id="email"
                    type="text"
                    name="email"
                    autoFocus
                    placeholder="Wpisz adres email"
                    value={this.state.email}
                    onChange={e => this.handleEmailChange(e)}
                  />
                </Tab>
                <Tab eventKey={'username'} title="Nazwa użytkownika" tabClassName={s.resetTab}>
                  <label className={s.label} htmlFor="username">
                    Nazwa użytkownika:
                  </label>
                  <input
                    className={s.input}
                    id="username"
                    type="text"
                    name="username"
                    autoFocus
                    placeholder="Wpisz nazwę użytkownika"
                    value={this.state.username}
                    onChange={e => this.handleUsernameChange(e)}
                  />
                </Tab>
              </Tabs>
              <button className={s.button} type="submit">
                Resetuj
              </button>
            </div>
          </form>
          {
            this.state.formSent === true ?
              <div>Udało się zresetować hasło. Sprawdź hasło w swojej skrzynce odbiorczej email i zaloguj ponownie.
                <div>Przekierowanie do strony ustawiania hasła nastapi za {this.state.timeToFire} sekund</div>
              </div> :
              null
          }
          {
            this.state.errorMessage !== null ?
              <div className={s.errorMsg}>{this.state.errorMessage}</div> :
              null
          }
        </div>
      </div>
    );
  }
}

export default withStyles(s)(ResetPassword);



// WEBPACK FOOTER //
// src/routes/login/resetPassword/ResetPassword.js